import { useIntl } from "@jetshop/intl"
import React, { useContext } from 'react'
import { SiteContext } from "../../../Global/SiteContext"
import { formatDate } from "../../../Core/Util/Helpers"
import { STOCK_ID } from "../../../Core/Util/Constants"

const getLatestPackagePreBookDate = products => {
   if (!Array.isArray(products)) {
      return null
   }

   const isOutOfStock = products?.some(item =>
      STOCK_ID.OUT_OF_STOCK.includes(
         item?.product?.variants?.values[0]?.stockStatus?.stockStatusId
      )
   )

   if (isOutOfStock) {
      return null
   }

   const packagePrebookItems = products?.filter(
      productItem => STOCK_ID.PREBOOK.includes(
         productItem?.product?.variants?.values[0]?.stockStatus?.stockStatusId
      )
   )

   const latestPreBookDate = packagePrebookItems?.reduce((latestDate, productItem) => {
      const dateString = productItem?.product?.customFields?.find(p => p?.key === 'BerLevDatum')?.stringValue

      if (typeof dateString !== 'string' || dateString.trim() === '') return latestDate;
      
      const currentDate = dateString.split(' ')[0]
      if (!latestDate || currentDate > latestDate) {
         return currentDate
      }
      return latestDate
   }, null)

   return latestPreBookDate
}

const PreOrderDate = ({ productData }) => {
   const t = useIntl()
   const { activeVariant, packageProducts } = useContext(SiteContext)
   
   const productPreOrderDate = formatDate(productData.customFields.find(p => p.key == 'BerLevDatum')?.stringValue)
   const packagePreOrderDate = getLatestPackagePreBookDate(packageProducts)

   const preOrderDate =
      productPreOrderDate && STOCK_ID.PREBOOK.includes(activeVariant?.stockStatus?.stockStatusId)
         ? productPreOrderDate
         : packagePreOrderDate

   if (!preOrderDate) {
      return null
   }

   return (
      <span className="back-in-stock-text">
         {t('Back in stock')} {preOrderDate}
      </span>
   )
}

export default PreOrderDate